<template>
    <div class="trophies-page">
        <div class="page-head">
            <div class="left">
                <h1>Manage trophies</h1>
            </div>
        </div>
        <TrophiesList></TrophiesList>
    </div>
</template>

<script>
    import TrophiesList from "@/components/Trophies/TrophiesList"

    export default {
        name: "Trophies",
        components: {
            TrophiesList
        },

        methods: {

        },
        mounted() {}
    };
</script>
